export default __webpack_public_path__ + "static/media/3.1f7f3a2e.jpg";